import { AGENT_IDS, DATA_CATALOG_API_TOOL_IDS } from '@/app/data-catalog/_common/constants'
import { useApiRequest } from '@/lib/http-utils'
import { useMutation } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'

export type TableUpdate = {
  table_name: string
  table_description: string
}

export type TableMetadataUpdate = {
  service_name: string
  database_name: string
  schema_name: string
  tables: TableUpdate[]
}

export type TableMetadataUpdateResult = {
  table_name: string
}

export type SchemaUpdateResult = {
  success: boolean
  schema_fqn: string
  updated_tables: TableMetadataUpdateResult[]
  failed_tables: TableMetadataUpdateResult[]
}

export type SaveTableMetadataResponse = {
  success: boolean
  updates: SchemaUpdateResult[]
}

export type SaveTableMetadataParams = {
  service_name: string
  database_name: string
  schema_name: string
  tables: TableUpdate[]
}

export function useSaveTableMetadataMutation() {
  const agentId = AGENT_IDS.DATA_CATALOG_AGENT
  const { apiRequest, domainId } = useApiRequest()

  return useMutation<{ output: SaveTableMetadataResponse }, Error, SaveTableMetadataParams>({
    mutationFn: async (params) => {
      const basePath = taskManagerApiPaths.agentById({ domainId, agentId })

      const payload = {
        tableMetadataUpdate: {
          service_name: params.service_name,
          database_name: params.database_name,
          schema_name: params.schema_name,
          tables: params.tables,
        },
      }

      const response = await apiRequest({
        path: basePath,
        queryParams: {
          tool_id: DATA_CATALOG_API_TOOL_IDS.UPDATE_TABLE_METADATA,
        },
        options: {
          method: 'POST',
          body: JSON.stringify(payload),
        },
      })

      const json = (await response.json()) as { output: SaveTableMetadataResponse }
      return json
    },
  })
}
